module.exports = __webpack_public_path__ + "images/empty_cockpit_list_icon.a297b0a4846fd222a9ed6aff5fb05c5b.png";